import * as React from "react";

const PasswordShow = (props) => (
  <svg width={36} height={36} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 4.5c-3.375 0-6.3.9-8.775 2.7l1.8 1.575C13.05 7.425 15.3 6.75 18 6.75c7.425 0 13.5 6.075 13.5 13.5h2.25C33.75 11.475 26.775 4.5 18 4.5ZM2.25 6.75l3.6 3.375c-2.25 2.7-3.6 6.3-3.6 10.125H4.5c0-3.375 1.125-6.3 3.15-8.55l4.95 4.5c-.9 1.125-1.35 2.475-1.35 4.05 0 3.825 2.925 6.75 6.75 6.75 1.8 0 3.375-.675 4.5-1.8l6.75 6.3 1.575-1.575-27-24.75L2.25 6.75Zm11.925 11.025L20.7 23.85c-.675.45-1.575.9-2.7.9a4.513 4.513 0 0 1-4.5-4.5c0-.9.225-1.8.675-2.475Zm10.575 3.6L22.5 19.35c-.45-1.8-2.025-3.375-4.05-3.6l-2.25-2.025c.675-.225 1.125-.225 1.8-.225 3.825 0 6.75 2.925 6.75 6.75v1.125Z"
      fill="#000"
      fillOpacity={0.4}
    />
  </svg>
);

export default PasswordShow;
